import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { AdminSideNavbar } from '../../components/navbars/AdminSideNavbar'
import { UserNavbar } from '../../components/navbars/UserNavbar'

export function SuperAdminLayout() {
	const isAuthenticated = useSelector((s) => s.auth.isAuthenticated)
	const user = useSelector((s) => s.auth.user)
	const checkAuthLoading = useSelector((s) => s.auth.checkAuthLoading)

	if (checkAuthLoading) {
		return <h1>Loading ...</h1>
	}
	if (!isAuthenticated) return <Navigate to="/login" replace />
	if (!user?.isSuperAdmin) return <Navigate to="/user-dashboard" replace />

	return (
		<main className="afterLoginMain">
			<AdminSideNavbar />
			<div className="afterLoginMainLayout">
				<UserNavbar />
				<Outlet />
			</div>
		</main>
	)
}
